import {useSessionStore, useUserStore} from '@/stores'
import useNetworkMachine from '@/state/useNetworkMachine'
import {useParticipantDisconnected} from './useParticipantDisconnected'
import {onMounted, onUnmounted} from 'vue'
import {jsonRpc} from '@communication'

// A party whose socket closed without con:disjoin is marked as gone and turns on the "lost network connection" toast
// (useParticipantDisconnectedCallback). Its con:joined after the re-join clears that again, as every con:joined did before
// 5.1.0 (JsonRpc.joinedHandler; 5ba58c7 moved it here without registering the procedure). The server also sends
// con:joined for everyone already in the call after our own (re-)join, which clears a re-join we missed while offline
export const useParticipantJoinedCallback = () => {
  const {roleLeave} = useParticipantDisconnected()

  const handleParticipantJoined = (event: CustomEvent) => {
    const {id, party} = event.detail ?? {}
    const session = useSessionStore()
    const user = useUserStore()
    const gone = session.participantsLeave.find((entry: string) => entry.endsWith(`_${id}`))
    if (!gone) return
    session.removeParticipantsLeave(gone)
    // During our own outage the toast stays until our session is back (useParticipantDisconnectedCallback)
    if (session.participantsLeave.includes(`${user.party}_${user.id}`)) return
    const {send, state} = useNetworkMachine()
    if (!state.value.matches('connectionNetwork.offline')) return
    // The toast reports the latest connection event: the success text names the party that came back (roleLeave may
    // still name another party that dropped later, e.g. an observer)
    roleLeave.value = party || gone.slice(0, gone.lastIndexOf('_'))
    send('ONLINE_CONNECTION')
  }
  onMounted(() => {
    jsonRpc.on('con:joined', handleParticipantJoined)
  })
  onUnmounted(() => {
    jsonRpc.off('con:joined', handleParticipantJoined)
  })
}
